// src/components/CookieConsent.js

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '../context/CookieConsentContext';
import './CookieConsent.css';

const COOKIE_CONSENT_EXIT_MS = 380;

const CookieConsent = () => {
  const {
    showBanner,
    hasAcknowledged,
    acknowledgeEssential,
    closeCookieSettings,
  } = useCookieConsent();

  const [isExiting, setIsExiting] = useState(false);
  const exitTimerRef = useRef(null);

  useEffect(() => {
    if (showBanner) setIsExiting(false);
  }, [showBanner]);

  useEffect(() => () => {
    if (exitTimerRef.current) clearTimeout(exitTimerRef.current);
  }, []);

  const isReopen = hasAcknowledged;

  const handleDismiss = useCallback(() => {
    if (isExiting) return;
    setIsExiting(true);
    exitTimerRef.current = window.setTimeout(() => {
      exitTimerRef.current = null;
      if (isReopen) closeCookieSettings();
      else acknowledgeEssential();
      setIsExiting(false);
    }, COOKIE_CONSENT_EXIT_MS);
  }, [isExiting, isReopen, closeCookieSettings, acknowledgeEssential]);

  if (!showBanner && !isExiting) return null;

  return (
    <div
      className={`cookie-consent${isExiting ? ' cookie-consent--exit' : ''}`}
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
    >
      <div className="cookie-consent-inner">
        <div className="cookie-consent-copy">
          <p className="cookie-consent-title" id="cookie-consent-title">
            Cookies &amp; essential storage
          </p>
          <p className="cookie-consent-desc" id="cookie-consent-desc">
            We use cookies and local storage only for essential features: signing you in, keeping
            your session secure, and remembering in-app preferences (for example layout and upload
            state). We do not use analytics or marketing trackers on this site. See our{' '}
            <Link to="/privacy" className="cookie-consent-link">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button
            type="button"
            className="cookie-consent-btn cookie-consent-btn--primary"
            onClick={handleDismiss}
            disabled={isExiting}
            aria-busy={isExiting}
          >
            Understood
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
